// extracted by css-extract-rspack-plugin
export default {"DatasetValueProp":"yvbEc"};